'use client';

import { usePathname } from 'next/navigation';
import { useCallback, useEffect, useState } from 'react';

import { Modal } from '@bytel/trilogy-react';

import { getAppConfig } from '@services/config';

import { CartModal } from '@components/modal/cart-modal';
import { SSIBlock } from '@components/ssi-block';

import { useCartHeader } from '@hooks/use-cart-header';

import { paths } from '@helpers/path';

const appConfig = getAppConfig();

export function Header() {
    const { hasItems, itemsCount } = useCartHeader();
    const [shouldShowModal, setShouldShowModal] = useState(false);
    const [cartModalTitle, setCartModalTitle] = useState('Votre panier est vide');

    // Mémorisation des callbacks pour éviter les re-renders inutiles
    const openModalCart = useCallback(() => setShouldShowModal(true), []);
    const closeModalCart = useCallback(() => setShouldShowModal(false), []);

    useEffect(() => {
        setCartModalTitle(hasItems ? 'Détails du panier' : 'Votre panier est vide');
    }, [hasItems]);

    useEffect(() => {
        document.addEventListener('action:panier:click', openModalCart);
        return () => {
            document.removeEventListener('action:panier:click', openModalCart);
        };
    }, [openModalCart]);

    useEffect(() => {
        setTimeout(() => {
            window.postMessage({ shopPanier: { badge: itemsCount.toString() } });
        }, 100);
    }, [itemsCount]);

    const path = usePathname();
    const isHomepage = [paths.plans, paths.fai, paths.packs].includes(path);
    const HEADER_PATHS = {
        FULL: appConfig.assets.partials.header.default,
        LIGHT: appConfig.assets.partials.header.light,
    };

    return (
        <>
            <SSIBlock url={isHomepage ? HEADER_PATHS.FULL : HEADER_PATHS.LIGHT} />
            <Modal title={cartModalTitle} active={shouldShowModal} onClose={closeModalCart}>
                <CartModal onClose={closeModalCart} />
            </Modal>
        </>
    );
}
